import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './sliding-banner.css';

const defaultSlides = [
    {
        id: 1,
        badge: 'Limited Time',
        title: 'Flat 10% OFF on All Amazon Vouchers',
        subtitle: 'Use code SAVE10 at checkout',
        cta: 'Shop Now',
        link: '/explore',
        bg: 'linear-gradient(135deg, #ff9a3c 0%, #ff6b1a 100%)',
        emoji: '🎁'
    },
    {
        id: 2,
        badge: 'Hot Deal',
        title: 'Gaming Gift Cards — Save up to 15%',
        subtitle: 'PlayStation, Xbox, Steam & more',
        cta: 'Browse Gaming',
        link: '/explore',
        bg: 'linear-gradient(135deg, #7850ff 0%, #4a2dbd 100%)',
        emoji: '🎮'
    },
    {
        id: 3,
        badge: 'Exclusive',
        title: 'Instant Food Vouchers — 8% Back',
        subtitle: 'Swiggy, Zomato, Dominos & more',
        cta: 'Order Now',
        link: '/explore',
        bg: 'linear-gradient(135deg, #ff6b6b 0%, #c2185b 100%)',
        emoji: '🍔'
    },
    {
        id: 4,
        badge: 'New',
        title: 'Fuel Vouchers with Zero Fees',
        subtitle: 'IOCL, BPCL, HPCL accepted',
        cta: 'Get Vouchers',
        link: '/explore',
        bg: 'linear-gradient(135deg, #2b9b8f 0%, #0d6b63 100%)',
        emoji: '⛽'
    }
];

function SlidingBanner({ slides = defaultSlides, interval = 4000 }) {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const t = setInterval(() => {
            setIndex((i) => (i + 1) % slides.length);
        }, interval);
        return () => clearInterval(t);
    }, [slides.length, interval]);

    return (
        <section className="dt-sb-section">
            <div className="dt-sb-container">
                <div className="dt-sb-viewport">
                    <div
                        className="dt-sb-track"
                        style={{ transform: `translateX(-${index * 100}%)` }}
                    >
                        {slides.map((s) => (
                            <div
                                key={s.id}
                                className="dt-sb-slide"
                                style={{ background: s.bg }}
                            >
                                <div className="dt-sb-pattern" aria-hidden="true"></div>

                                <div className="dt-sb-content">
                                    <span className="dt-sb-badge">{s.badge}</span>
                                    <h3 className="dt-sb-title">{s.title}</h3>
                                    <p className="dt-sb-subtitle">{s.subtitle}</p>
                                    <Link to={s.link} className="dt-sb-cta">
                                        {s.cta}
                                        <span className="dt-sb-arrow">→</span>
                                    </Link>
                                </div>

                                <div className="dt-sb-emoji" aria-hidden="true">{s.emoji}</div>
                            </div>
                        ))}
                    </div>

                    {/* Dots */}
                    <div className="dt-sb-dots">
                        {slides.map((_, i) => (
                            <button
                                key={i}
                                className={`dt-sb-dot ${index === i ? 'active' : ''}`}
                                onClick={() => setIndex(i)}
                                aria-label={`Slide ${i + 1}`}
                            />
                        ))}
                    </div>

                    {/* Arrows */}
                    <button
                        className="dt-sb-nav dt-sb-prev"
                        onClick={() => setIndex((i) => (i - 1 + slides.length) % slides.length)}
                        aria-label="Previous"
                    >
                        ‹
                    </button>
                    <button
                        className="dt-sb-nav dt-sb-next"
                        onClick={() => setIndex((i) => (i + 1) % slides.length)}
                        aria-label="Next"
                    >
                        ›
                    </button>
                </div>
            </div>
        </section>
    );
}

export default SlidingBanner;
